import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { SectionCta } from '../SectionCta';
import { beforeItems, afterItems } from '../../data/content';
export function BeforeAfter() {
  return <section className="bg-mist-50 px-4 py-16 md:px-8 md:py-24" data-id="element-72" data-mp="26ll08frx8f20">
      <div className="mx-auto max-w-5xl" data-id="element-73" data-mp="26k03cji4wk0z">
        <div className="text-center" data-id="element-74" data-mp="22lsoju78dssf">
          <p className="text-sm font-extrabold uppercase tracking-wide text-brand-700" data-id="element-75" data-mp="22iockanixsr7">From scattered findings to structured clinical reasoning</p>
          <h2 className="mt-3 text-[28px] font-extrabold leading-tight tracking-tight text-ink-900 md:text-4xl" data-id="element-76" data-mp="2ubf96m94djgz">
            See what changes when you have a clear workflow.
          </h2>
        </div>

        <div className="mt-10 grid gap-6 md:grid-cols-2" data-id="element-77" data-mp="2lc20vwwqf0xu">
          <div className="rounded-3xl bg-white p-6 ring-2 ring-red-200 md:p-8" data-id="element-78" data-mp="2ldlgdlakd7yk">
            <div className="flex items-center gap-3" data-id="element-79" data-mp="1ewhxj4foncrh">
              <span className="rounded-full bg-red-600 px-4 py-1.5 text-sm font-extrabold uppercase text-white" data-id="element-80" data-mp="19vu64hnjktwq">Before</span>
              <span className="text-[15px] font-bold text-red-700" data-id="element-81" data-mp="176nq42udpla6">Without a structured system</span>
            </div>
            <ul className="mt-6 space-y-4" data-id="element-82" data-mp="1c3nvebjemk08">
              {beforeItems.map(b => <li key={b} className="flex items-start gap-3 text-[16px] font-medium text-ink-800" data-id="element-83" data-mp="y462bjz2skl2">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-red-100 text-red-600" data-id="element-84" data-mp="1327mk888mpy4">
                    <XIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-85" data-mp="t5l2hlnqk2x5" />
                  </span>
                  {b}
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl bg-ink-900 p-6 text-white ring-2 ring-brand-400 md:p-8" data-id="element-86" data-mp="fcdd80n4njim">
            <div className="flex flex-wrap items-center gap-3" data-id="element-87" data-mp="jdf9q9pnthgw">
              <span className="rounded-full bg-brand-400 px-4 py-1.5 text-sm font-extrabold uppercase text-ink-950" data-id="element-88" data-mp="5giocnsb8s7e">After</span>
              <span className="text-[15px] font-bold text-brand-300" data-id="element-89" data-mp="agxzd8p4dnm7">With the Endo Retreatment Decision Pathway™</span>
            </div>
            <ul className="mt-6 space-y-4" data-id="element-90" data-mp="27d11ds6oli6s">
              {afterItems.map(a => <li key={a} className="flex items-start gap-3 text-[16px] font-semibold" data-id="element-91" data-mp="23bpgfzyr5l4x">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand-400 text-ink-950" data-id="element-92" data-mp="1ycurega6z0cd">
                    <CheckIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-93" data-mp="2v23ovgnzy597" />
                  </span>
                  {a}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mt-8 text-center text-lg font-bold text-ink-900" data-id="element-94" data-mp="2m15mf2t7i5sq">
          Same professional expertise. <span className="text-brand-700" data-id="element-95" data-mp="2h2u9ukbj1h6t">A more organized way to apply and document it.</span>
        </p>

        <SectionCta label="I want the structured workflow" data-id="element-96" data-mp="1aol7xl0gaooe" />
      </div>
    </section>;
}